import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setFinParameters } from '../actions/actionsAppTest';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded, fetchSimulationOptionsIfNeeded,
  fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import TestParameters from '../components/testCriteria/TestParameters'

export default function ContTestParameters() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeParameters(parameters) {
    const paramsFetch = parameters == null ? '' : parameters;
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, false);
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, null, false);
    dispatch(setFinParameters(parameters))
  }

  return (
    <TestParameters
      parameters={globalstate.testCriteria.parameters}
      settings={globalstate.settings}
      onChangeParameters={onChangeParameters}
    />
  );
}
